import React, { useEffect, useState } from "react";
import { SuccessIcon, ErrorIcon, WarningIcon, InfoIcon } from "../Icons/ToastIcons";
import "./Toast.css";

export type ToastType = "success" | "error" | "warning" | "info";

export interface ToastMessage {
  id: string;
  type: ToastType;
  message: string;
  duration?: number;
  createdAt?: number; // 添加创建时间戳
}

interface ToastProps {
  message: ToastMessage;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ message, onClose }) => {
  const {
    id,
    type,
    message: content,
    duration = 2500,
    createdAt = Date.now(),
  } = message;
  const [visible, setVisible] = useState(false);
  const [removing, setRemoving] = useState(false);

  useEffect(() => {
    // 进入动画
    setTimeout(() => setVisible(true), 10);

    // 计算实际剩余时间
    const elapsedTime = Date.now() - createdAt;
    const remainingTime = Math.max(duration - elapsedTime, 0);

    // 设置自动关闭
    const timer = setTimeout(() => {
      setRemoving(true); // 先添加removing类
      setVisible(false);
      // 等待退出动画完成后移除
      setTimeout(() => onClose(id), 300);
    }, remainingTime);

    return () => clearTimeout(timer);
  }, [id, duration, onClose, createdAt]);

  const getIcon = () => {
    switch (type) {
      case "success":
        return <SuccessIcon />;
      case "error":
        return <ErrorIcon />;
      case "warning":
        return <WarningIcon />;
      case "info":
        return <InfoIcon />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`toast toast-${type} ${visible ? "visible" : ""} ${
        removing ? "removing" : ""
      }`}
    >
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-content">{content}</div>
    </div>
  );
};

export default Toast;
